(() => {
  const rows = new WeakMap();
  function setup(root = document) {
    root.querySelectorAll('[data-coi-carousel]').forEach(row => {
      if (rows.has(row)) return;
      const scope = row.closest('.shopify-section') || row.parentElement;
      const previous = scope.querySelector('[data-coi-prev]');
      const next = scope.querySelector('[data-coi-next]');
      const fill = document.getElementById(row.id + '-progress-fill');
      const controller = new AbortController();
      const signal = controller.signal;
      function update() {
        const maximum = Math.max(0, row.scrollWidth - row.clientWidth);
        const position = Math.abs(row.scrollLeft);
        if (previous) previous.disabled = position <= 2;
        if (next) next.disabled = position >= maximum - 2;
        if (fill) fill.style.width = (maximum ? Math.min(100, position / maximum * 100) : 100) + '%';
      }
      function move(direction) {
        const first = row.firstElementChild;
        if (!first) return;
        const distance = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
        row.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      previous?.addEventListener('click', () => move(-1), {signal});
      next?.addEventListener('click', () => move(1), {signal});
      row.addEventListener('keydown', event => {
        if (event.target !== row || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') row.scrollLeft = 0;
        else if (event.key === 'End') row.scrollLeft = row.scrollWidth;
        else move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      row.addEventListener('scroll', update, {passive:true, signal});
      const observer = new ResizeObserver(update);
      observer.observe(row);
      rows.set(row, () => {controller.abort();observer.disconnect();rows.delete(row);});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), {once:true});
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-coi-carousel]').forEach(row => rows.get(row)?.()));
})();
